import { getSavedState, removeState, saveState } from '@state/helpers'

const SHOULD_SHOW_WELCOME_OVERLAY_KEY = 'onboarding.shouldShowWelcomeOverlay'

export const state = {
  allSteps: [],
  hasPendingOnboarding: false,
  shouldShowWelcomeOverlay: getSavedState(SHOULD_SHOW_WELCOME_OVERLAY_KEY, false),
}

export const getters = {
  allSteps(state) {
    return state.allSteps
  },
  hasPendingOnboarding(state, getters, rootState, rootGetters) {
    return rootGetters['user/canAccessOnboarding'] && state.hasPendingOnboarding
  },
  shouldShowWelcomeOverlay(state) {
    return state.shouldShowWelcomeOverlay
  },
}

export const mutations = {
  SET_ALL_STEPS(state, steps) {
    state.allSteps = steps
  },
  SET_HAS_PENDING_ONBOARDING(state, value) {
    state.hasPendingOnboarding = value
  },
  SET_SHOULD_SHOW_WELCOME_OVERLAY(state, value) {
    state.shouldShowWelcomeOverlay = value
    if (value) {
      saveState(SHOULD_SHOW_WELCOME_OVERLAY_KEY, true)
      return
    }

    removeState(SHOULD_SHOW_WELCOME_OVERLAY_KEY)
  },
}
